module.exports = __webpack_public_path__ + "img/staff-roles.af80f608.svg";